import { getMomentColor, mapMoment } from "../constants/moments.js";
import { logDev } from "../utils/logger.js";

export const buildTableRows = (items, contacts, saisies) => {

  // 🔄 Construction des lignes de base (une par article fusionné)
  const lignes = items.map((item, index) => {
    const safeMoment =
      item.source === "custom"
        ? "Custom"
        : item.moment
        ? mapMoment(item.moment) || item.moment
        : "Custom";

    const safeColor = item.color || getMomentColor(safeMoment);

    const baseRow = {
      // 🔑 Identifiant unique basé sur articleId (menus + custom)
      id: String(item.articleId), 
      _id: String(item.articleId),                      // utilisé pour associer les saisies

      // 🗂️ Catégorie (thème)
      theme: item.categorie || "",

      // 🏷️ Infos affichées dans la colonne "quoi"
      quoi: {
        label: item.name,
        moment: safeMoment,
        categorie: item.categorie,
        icon: item.icon,

        // 🎨 Tag couleur pour le rendu dans la colonne "quoi"
        colorTag: (() => {
          const cat = item.categorie?.toLowerCase();
          const isCustom = item.moment === "Custom" || item.source === "custom";

          if (cat === "boisson" || cat?.includes("boisson")) return "boisson";
          if (cat === "apéro" || cat === "apero") return "apero";
          if (isCustom) return "custom";
          return null;
        })(),

        },
      

      color: safeColor,

      // 🔢 Quantité totale attendue (menus + custom)
      quantite: item.totalQuantity ?? item.quantity ?? 0,

      source: item.source,

      // 👥 Colonnes dynamiques pour chaque contact
      ...Object.fromEntries(contacts.map((c) => [`contact_${c._id}`, ""]))
    };

    baseRow.pris = 0; // total pris par tous les contacts
    return baseRow;
  });

  logDev("[buildTableRows] lignes de base construites", lignes);

  // ---------------------------------------------------------
  // Injection des saisies existantes (valeurs déjà apportées)
  // ---------------------------------------------------------
  const lignesAvecSaisies = lignes.map((row) => {
    // 🔍 On récupère les saisies correspondant à cet article
    const saisiesPourItem = row._id
      ? saisies.filter((s) => String(s.item) === String(row._id))
      : [];

    const updatedRow = { ...row };

    // ✏️ On remplit les colonnes contact_xxx
    saisiesPourItem.forEach((s) => {
      updatedRow[`contact_${s.contactId}`] = s.value;
      logDev("[buildTableRows] saisie injectée", {
        itemId: row._id,
        contactId: s.contactId,
        value: s.value
      });
    });

    // ➕ Calcul du total pris (somme des valeurs contact_xxx)
    updatedRow.pris = contacts.reduce((sum, contact) => {
      const val = parseFloat(updatedRow[`contact_${contact._id}`]);
      return sum + (isNaN(val) ? 0 : val);
    }, 0);

    logDev("[buildTableRows] ligne mise à jour avec total pris", updatedRow);
    return updatedRow;
  });

  // ---------------------------------------------------------
  // 🔠 Tri final par catégorie
  // ---------------------------------------------------------
  const ordreThemes = [
    "Sucré",
    "Salé",
    "Boisson (Matin)",
    "Apéro",
    "Entrée",
    "Plat",
    "Dessert",
    "Boisson (Midi/Soir)",
  ];

  return lignesAvecSaisies.sort((a, b) => {
    const indexA = ordreThemes.indexOf(a.theme);
    const indexB = ordreThemes.indexOf(b.theme);

    if (indexA !== -1 && indexB !== -1) return indexA - indexB;
    if (indexA === -1 && indexB !== -1) return 1;
    if (indexA !== -1 && indexB === -1) return -1;

    return a.theme.localeCompare(b.theme);
  });
};
